var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVideo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 12,
    viewBox: "0 0 18 12",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.16663 0.166748C2.50358 0.166748 1.8677 0.43014 1.39886 0.898981C0.930018 1.36782 0.666626 2.00371 0.666626 2.66675V9.33341C0.666626 9.99646 0.930018 10.6323 1.39886 11.1012C1.8677 11.57 2.50358 11.8334 3.16663 11.8334H11.5C12.163 11.8334 12.7989 11.57 13.2677 11.1012C13.7366 10.6323 14 9.99646 14 9.33341V8.01175L15.9108 9.92258C16.0273 10.0391 16.1758 10.1184 16.3374 10.1506C16.4991 10.1827 16.6666 10.1662 16.8188 10.1031C16.9711 10.0401 17.1012 9.9333 17.1928 9.7963C17.2844 9.65929 17.3333 9.49821 17.3333 9.33341V2.66675C17.3333 2.50196 17.2844 2.34087 17.1928 2.20387C17.1012 2.06686 16.9711 1.96007 16.8188 1.89702C16.6666 1.83396 16.4991 1.81746 16.3374 1.84959C16.1758 1.88173 16.0273 1.96107 15.9108 2.07758L14 3.98842V2.66675C14 2.00371 13.7366 1.36782 13.2677 0.898981C12.7989 0.43014 12.163 0.166748 11.5 0.166748H3.16663Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideo);
export default __webpack_public_path__ + "static/media/video.77a393437b91a5b701a2f9d6dbfdea36.svg";
export { ForwardRef as ReactComponent };